// extracted by css-extract-rspack-plugin
export default {"root":"root-AASAWi","panel":"panel-bmU3kD","list":"list-r9RpbV","item":"item-V9Fp7k","swiperWrapper":"swiperWrapper-vmuekT","chevron":"chevron-IcTMjK"};